module.exports = __webpack_public_path__ + "src/assets/img/邮件拷贝.png";